//import external from '../externalModules.js';
import { getEnabledElement } from "component/toolManager/enabledElements.js";

function makeImageId(elementId, imageSOPUID) {
  const imageId = elementId + "_" + imageSOPUID;
  return imageId;
}

/**
 * Implements an imageId specific tool state management strategy.  This means that
 * Measurements data is tied to a specific imageId and only visible for enabled elements
 * That are displaying that imageId.
 * @public
 * @constructor newImageIdSpecificToolStateManager
 * @memberof StateManagement
 *
 * @returns {Object} An imageIdSpecificToolStateManager instance.
 */
function newImageIdSpecificToolStateManager() {
  let toolState = {};

  // Here we add tool state, this is done by tools as well
  // As modules that restore saved state

  function saveImageIdToolState(imageId) {
    return toolState[imageId];
  }

  function restoreImageIdToolState(imageId, imageIdToolState) {
    toolState[imageId] = imageIdToolState;
  }

  function saveToolState() {
    return toolState;
  }

  function restoreToolState(savedToolState) {
    toolState = savedToolState;
  }

  /**
   * @description 사용자가 그리기 한 내역을 저장하는 메서드
   * 저장되는 그리기 정보의 Key는 그리기가 진행된 Element의 ID + "_" + 해당 DICOM영상의
   *
   *
   * @param {*} element
   * @param {*} toolType
   * @param {*} data
   * @returns
   */
  function addImageIdSpecificToolState(element, toolType, data) {
    const enabledElement = getEnabledElement(element);

    // If we don't have an image for this element exit early
    if (!enabledElement.image) {
      return;
    }
    const imageId = makeImageId(
      element.id,
      enabledElement.image.sopInstanceUID
    );
    // If we don't have any tool state for this imageId, add an empty object
    if (toolState.hasOwnProperty(imageId) === false) {
      toolState[imageId] = {};
    }

    const imageIdToolState = toolState[imageId];

    // If we don't have tool state for this type of tool, add an empty object
    if (imageIdToolState.hasOwnProperty(toolType) === false) {
      imageIdToolState[toolType] = {
        data: []
      };
    }

    const toolData = imageIdToolState[toolType];

    // Finally, add this new tool to the state
    toolData.data.push(data);
  }

  // Here you can get state - used by tools as well as modules
  // That save state persistently
  function getImageIdSpecificToolState(element, toolType) {
    const enabledElement = getEnabledElement(element);
    // If we don't have any tool state for this imageId, return undefined

    const imageId = makeImageId(
      element.id,
      enabledElement.image.sopInstanceUID
    );

    if (!enabledElement.image || toolState.hasOwnProperty(imageId) === false) {
      return;
    }

    const imageIdToolState = toolState[imageId];

    // If we don't have tool state for this type of tool, return undefined
    if (imageIdToolState.hasOwnProperty(toolType) === false) {
      return;
    }

    const toolData = imageIdToolState[toolType];

    return toolData;
  }

  // Clears all tool data from this toolStateManager.
  function clearSpecificViewport(element) {
    const enabledElement = getEnabledElement(element);

    if (enabledElement.image === undefined || enabledElement.image === null) {
      return;
    }

    const imageId = makeImageId(
      element.id,
      enabledElement.image.sopInstanceUID
    );
    if (!enabledElement.image || toolState.hasOwnProperty(imageId) === false) {
      return;
    }
    for (let key in toolState) {
      if (key === "") {
        return;
      }
      let s = key.split("_");
      if (s.length === 0) {
        return;
      }

      let viewId = s[0];

      if (element.id === viewId) {
        delete toolState[key];
      }
    }
  }

  // Clears all tool data from this toolStateManager.
  function clearImageIdSpecificToolStateManager(element) {
    const enabledElement = getEnabledElement(element);

    const imageId = makeImageId(
      element.id,
      enabledElement.image.sopInstanceUID
    );

    if (!enabledElement.image || toolState.hasOwnProperty(imageId) === false) {
      return;
    }

    delete toolState[imageId];
  }

  // Clears all tool data from this toolStateManager.
  function clearAll() {
    for (const key in toolState) {
      delete toolState[key];
    }
    //toolState.clear();
  }
  return {
    get: getImageIdSpecificToolState,
    add: addImageIdSpecificToolState,
    clearView: clearSpecificViewport,
    clear: clearImageIdSpecificToolStateManager,
    clearAll: clearAll,
    saveImageIdToolState,
    restoreImageIdToolState,
    saveToolState,
    restoreToolState,
    toolState
  };
}

const globalImageIdSpecificToolStateManager = newImageIdSpecificToolStateManager();

export {
  newImageIdSpecificToolStateManager,
  globalImageIdSpecificToolStateManager
};
